import type { Course } from '../types'

export const formatDate = (value: string) => new Intl.DateTimeFormat('es-CL', {
  day: 'numeric', month: 'long', year: 'numeric',
}).format(new Date(value))

export const courseLessonIds = (course: Course) => course.modules
  .flatMap((module) => module.lessons.map((lesson) => lesson.id))

export const courseProgress = (course: Course, completed: string[]) => {
  const lessonIds = courseLessonIds(course)
  if (!lessonIds.length) return 0
  return Math.round((lessonIds.filter((id) => completed.includes(id)).length / lessonIds.length) * 100)
}

export const downloadCsv = (filename: string, rows: Array<Record<string, string | number>>) => {
  if (!rows.length) return
  const headers = Object.keys(rows[0])
  const escape = (value: string | number) => `"${String(value).replaceAll('"', '""')}"`
  const csv = [headers.map(escape).join(','), ...rows.map((row) => headers.map((key) => escape(row[key])).join(','))].join('\n')
  const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.click()
  URL.revokeObjectURL(url)
}

export const safeId = (prefix: string) => `${prefix}-${crypto.randomUUID()}`
